import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    border-top: 1px solid #e5e5e5;
    margin-top: 8px;
`;

export const DeleteFileButton = styled.button`
    border: none;
    background: transparent;
    cursor: pointer;
    color: #d32f2f;
    transition: all 0.2s ease;

    &:hover {
        color: #b71c1c;
        transform: scale(1.1);
    }
`;
